module.exports = __webpack_public_path__ + "static/media/affiliations.5448944d.svg";